import { getTheoPlayerImportSource } from "./theoplayerRuntime";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";
import type Component from "video.js/dist/types/component";

export const getVideoJsComponent = (
  componentName:
    | "Button"
    | "FullscreenToggle"
    | "Component"
    | "MenuButton"
    | "MenuItem",
  runtime: THEOPlayerRuntime
): typeof Component => {
  const { THEOplayer: THEOplayerFromWindow } = window;
  const importSource = getTheoPlayerImportSource();

  const THEOplayer: THEOPlayerRuntime =
    importSource === "node-module"
      ? runtime
      : (THEOplayerFromWindow as THEOPlayerRuntime);

  if (!THEOplayer?.videojs) {
    throw new Error(
      importSource === "node-module"
        ? "THEOplayer runtime is not initialized"
        : "window.THEOplayer is not initialized"
    );
  }

  return THEOplayer.videojs.getComponent(componentName);
};
